// File: noviopus-ats-client/src/Main/selectors.ts
import { createSelector } from 'reselect';
import { RootState } from '@/App/storeTypes';

// Select Global (Legacy Immutable Chunk)
const selectGlobal = (state: any) => state.global;

// Select Route (Legacy Immutable Map from routeReducer)
const selectRoute = (state: any) => state.route;

export const selectCurrentUser = createSelector(
  (state: RootState) => state.auth,
  (auth) => auth.authUser
);

// Helper to extract location safely from Immutable route state
const getLocationFromRoute = (routeState: any) => {
    // If routeState is Immutable
    if (routeState && typeof routeState.get === 'function') {
        return routeState.get('locationBeforeTransitions');
    }
    // If POJO
    return routeState?.locationBeforeTransitions;
};

export const selectLocationState = createSelector(
  selectRoute,
  (routeState) => getLocationFromRoute(routeState)
);

export const currentUrl = () => createSelector(
  selectRoute,
  (routeState) => {
      const location = getLocationFromRoute(routeState);
      if (location && typeof location.get === 'function') {
          return location.get('pathname');
      }
      return location?.pathname;
  }
);

// FIX: Update to POJO access
export const getCurrentFormFields = (formName: string) => (state: any) =>
  state.form && state.form[formName]?.fields;

export const getSyncErrors = (formName: string) => (state: any) =>
  state.form && state.form[formName]?.syncErrors;